import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Notification from './index';
export var NotificationTemplateActions;
(function (NotificationTemplateActions) {
    NotificationTemplateActions["VIEW_MEDIA"] = "VIEW_MEDIA";
})(NotificationTemplateActions || (NotificationTemplateActions = {}));
var template = {
    castSuccess: function (args) {
        var notificationObject = args.data;
        var castedTemplate = React.createElement(React.Fragment, null,
            React.createElement("span", { onClick: function () { return args.onCallback && args.onCallback(notificationObject.mediaId || '', NotificationTemplateActions.VIEW_MEDIA); }, title: notificationObject.mediaName, className: "notification-media-content", style: { cursor: 'pointer', width: '88%', overflow: 'hidden', textOverflow: 'ellipsis' } },
                React.createElement("strong", null, notificationObject.mediaName)),
            React.createElement("span", null,
                ' ',
                React.createElement(FormattedMessage, { id: "ui_component.notification.successfully_casted_on", defaultMessage: "successfully casted on" }),
                ' '),
            React.createElement("span", null,
                React.createElement("strong", null,
                    React.createElement(FormattedMessage, { id: "ui_component.notification.screens_count", defaultMessage: "{num, number} {num, plural, one {screen} other {screens}}", values: { num: notificationObject.screenCount } }))));
        Notification.success({
            type: 'success',
            message: castedTemplate,
            thumbnail: React.createElement("img", { src: notificationObject.thumbnail }),
            duration: 100,
        });
    },
};
export default template;
//# sourceMappingURL=template.js.map